import AutodeskIcon from "@assets/icons/integrations/autodesk-icon_50px.svg?react";
import ProcoreIcon from "@assets/icons/integrations/procore-icon_50px.svg?react";
import { IntegrationInfo } from "@custom-types/integrations-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Information of each integration */
export const INTEGRATION_INFO: Record<
  FaroCoreApiTypes.IntegrationId,
  IntegrationInfo
> = {
  autodesk: {
    displayName: "Autodesk",
    description:
      "Create and view RFIs and Issues directly within the platform.",
    icon: AutodeskIcon,
  },
  procore: {
    displayName: "Procore",
    description:
      "Create and view RFIs and Observations directly within the platform.",
    icon: ProcoreIcon,
  },
};
